import React, { useState, useEffect } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import Cursor from '../SVG/Cursor';

interface ShowTypingProps {
  msg: string;
  txt: string;
  pic: string;
  vid: string;
  custom?: () => JSX.Element;
  renderCustom?: boolean;
  loading?: boolean;
  resumeTyping?: boolean;
  setIsTyping?: (isTyping: boolean) => void;
}

const ShowTyping: React.FC<ShowTypingProps> = ({ msg , txt, pic, vid, custom, renderCustom, loading, setIsTyping, resumeTyping }) => {  
  const [displayResponse, setDisplayResponse] = useState("");
  const [completedTyping, setCompletedTyping] = useState(false);
  const contentRef = React.useRef(null);
  const appendedElementRef = React.useRef(null);


  useEffect(() => {
    if (contentRef.current) {
      
      if (appendedElementRef.current) {
        (appendedElementRef.current as any).remove();
      }

      if(!completedTyping) {
        const lastElement = getDeepestLastChild(contentRef.current);
        if (lastElement) {
          const cursor = document.createElement('span');
          cursor.style.color = 'white';
          cursor.style.fontWeight = '1000';
          cursor.style.paddingLeft = '10px';
          cursor.textContent = '|';

          (appendedElementRef.current as any) = cursor;
          lastElement.appendChild(cursor);
        }  
      } 
    }
  }, [displayResponse]);

  useEffect(() => {
    setCompletedTyping(false);
    setIsTyping?.(true);

    let i = 0;
    const stringResponse = msg + txt;
    
    const intervalId = setInterval(() => {
      if (resumeTyping) {
        clearInterval(intervalId);
        setDisplayResponse(stringResponse);
        setCompletedTyping(true);
        setIsTyping?.(false);
        return;
      }

      setDisplayResponse(stringResponse.slice(0, i));
      i++;

      if (i > stringResponse.length) {
        clearInterval(intervalId);
        setCompletedTyping(true);  
        setIsTyping?.(false);
      }
    }, 5);
        
    return () => clearInterval(intervalId);
  }, [msg, resumeTyping]);
  
  // Custom Link component styled as a button
  type LinkProps = {
    href: string;
    children: React.ReactNode;
  };

  const components = {
    h2: ({node, ...props}: any) => <h2 className="center-align" {...props} />,
    h3: ({node, ...props}: any) => <h3 className="center-align" {...props} />,
    a: ({node, ...props}: any) => {
      //console.log("props.href: ", props.href);
      if (props && props.href.startsWith('/icon:')) {
        const iconType = props.href.split(':')[1];
        //console.log("iconType: ", iconType);
        return <img width="16px" height="16px" src={`/icons/${iconType}.svg`} alt={`${iconType} icon`} />;
      }
      return <a target="_blank" href={props.href} {...props}></a>;
    },
  };

  const getDeepestLastChild = (element: HTMLElement) => {
    let lastChild = element.lastElementChild;
  
    while (lastChild && lastChild.lastElementChild) {
      lastChild = lastChild.lastElementChild;
    }  
    return lastChild;
  };

  return (
    (loading)?
      <Cursor/> :    
      <div className='content' ref={contentRef}>      
        <ReactMarkdown
          //remarkPlugins={[remarkGfm]}
          components={components}
        >
          {displayResponse}
        </ReactMarkdown>
        {displayResponse === "" && <Cursor/>}
        {/* {!completedTyping && <Cursor/>} */}
        
        {/* Conditional rendering based on txt, pic, and vid props */}    
        {/*completedTyping && txt && <p>{txt}</p>*/}
        {completedTyping && pic && (pic !== "nan") && <p><img src={pic} alt="This is a picture!" /></p>}
        {completedTyping && vid && (vid !== "nan") && (
          <p>
            <video src={vid} controls>
            Your browser does not support the video tag.
            </video>
          </p>
        )}
        {renderCustom && custom &&
          <React.Fragment key="custom-component">
            {custom()}
          </React.Fragment>
        }
      </div>
  );

};

export default ShowTyping;